// Version : 0.0.1
// Author : VIGNESH
// LastEdit : VIGNESH
// Last ADD : REMOVED UNWANTED REDUX AND ADDED COMMENTS
// MODFIED DATA : 07-12-2025

// Verion : 0.0.2
// LastEdit : AGALYA
// Last ADD : ADDED COMMENTS
// MODFIED DATA : 28-02-2026

import { takeLatest, put, all, call } from 'redux-saga/effects';

import AccuredInterestReportTypes from './accured-interest-report.types';
import { getAccuredInterestReportDetails } from './accured-interest-report.service';
import {
	fetchAccuredInterestReportSuccess,
	fetchAccuredInterestReportFailure,
	fetchAccuredInterestReportResponseResetChanged,
} from './accured-interest-report.action';
import { encryptData } from '../../_common/enode-decode';

/** *********************  START FETCH AccuredInterest DETAILS  ******************** */
export function* fetchAccuredInterestReportDetails({ payload }: any) {
	try {
		const {
			companyID,
			databaseName,
			reportDate,
			branchID,
			groupID,
			centerID,
			funderID,
			memberID,
			searchByLoanModal,
			limit,
		} = payload;
		const key = 'GetAccuredInterestReportDetailsKey';
		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			ReportDate: reportDate,
			BranchID: branchID,
			GroupID: groupID,
			CenterID: centerID,
			FunderID: funderID,
			MemberID: memberID,
			SearchByLoanModal: searchByLoanModal,
			Limit: limit,
		};
		const encodeData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(getAccuredInterestReportDetails, encodeData);
		if (responseData.data.statusCode === '100') {
			yield put(fetchAccuredInterestReportFailure(responseData.data));
		} else {
			yield put(fetchAccuredInterestReportSuccess(responseData.data));
		}
	} catch (error) {
		yield put(fetchAccuredInterestReportFailure(error));
	}
}

export function* resetAccuredInterestReportResponse() {
	yield put(fetchAccuredInterestReportResponseResetChanged());
}

export function* onFetchAccuredInterestReportDetails() {
	yield takeLatest(
		AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_START,
		fetchAccuredInterestReportDetails,
	);
}

export function* onFetchAccuredInterestReportResponseReset() {
	yield takeLatest(
		AccuredInterestReportTypes.FETCH_ACCURED_INTEREST_REPORT_RESPONSE_RESET_START,
		resetAccuredInterestReportResponse,
	);
}
/** *********************  END FETCH AccuredInterest DETAILS ******************** */

export function* AccuredInterestReportSaga() {
	yield all([
		call(onFetchAccuredInterestReportDetails),
		call(onFetchAccuredInterestReportResponseReset),
	]);
}
